export default __webpack_public_path__ + "static/11-c716ef58fd1bbf720ad7e4cb02882b1c.jpg";